module.exports = __webpack_public_path__ + "static/media/Chicago.67429fb5.jpg";